// src/components/Utils/Sidebar.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, FileSpreadsheet, BookOpen } from "lucide-react";

type SidebarProps = {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  activeSection: "dashboard" | "settings";
};

// ✅ Updated iconMap with separate icon for Offline Course Registration
const iconMap: Record<string, JSX.Element> = {
  Home: <Home size={22} color="#007bff" />,
  "Student Records": <FileSpreadsheet size={22} color="#28a745" />,
  "Offline Course Registration": <BookOpen size={22} color="#28a745" />,
};

export default function Sidebar({
  sidebarCollapsed,
  toggleSidebar,
  activeSection,
}: SidebarProps) {
  const navigate = useNavigate();

  return (
    <>
      {/* Sidebar Toggle Button */}
      <button
        className={`menuToggleBtn ${sidebarCollapsed ? "sidebarCollapsed" : ""}`}
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        <div className="hamburgerIcon">
          <span className="hamburgerLine" />
          <span className="hamburgerLine" />
          <span className="hamburgerLine" />
        </div>
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        {/* Logo Section */}
        <div className="logoSection">
          <div
            className="logoCircle d-flex justify-content-center align-items-center shadow-sm mx-auto"
            style={{
              width: "95px",
              height: "95px",
              borderRadius: "50%",
              backgroundColor: "#fff",
              border: "2px solid #ddd",
              overflow: "hidden",
              padding: "10px",
            }}
          >
            <img
              src="/images/IIITB_logo1.png"
              alt="IIITB Logo"
              style={{
                width: "90%",
                height: "90%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </div>

          <div
            className="instituteName text-center"
            style={{
              fontFamily: "'Merriweather', serif",
              fontWeight: 600,
              fontSize: "1.3rem",
              color: "#161e27ff",
              lineHeight: "1.4",
              letterSpacing: "0.5px",
              whiteSpace: "pre-line",
            }}
          >
            {`International Institute of
Information Technology
Bangalore`}
          </div>
        </div>

        {/* Navigation Menu */}
        <div className="navMenu">

          {/* Home */}
          <button
            className="navItem"
            onClick={() => navigate("/upload")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "12px 14px",
              marginBottom: "12px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <span className="navIcon">{iconMap["Home"]}</span>
            <span className="navText" style={{ fontSize: "17px", fontWeight: 600 }}>
              Home
            </span>
          </button>

          {/* Student Records */}
          <button
            className="navItem"
            onClick={() => navigate("/records")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "12px 14px",
              marginBottom: "12px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <span className="navIcon">{iconMap["Student Records"]}</span>
            <span className="navText" style={{ fontSize: "17px", fontWeight: 600 }}>
              Student Records
            </span>
          </button>

          {/* Offline Course Registration */}
          <button
            className="navItem"
            onClick={() => navigate("/offline_course_registration")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "12px 14px",
              marginBottom: "12px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <span className="navIcon">{iconMap["Offline Course Registration"]}</span>
            <span className="navText" style={{ fontSize: "17px", fontWeight: 600 }}>
              Offline Course Registration
            </span>
          </button>

          <button
            className="navItem"
            onClick={() => navigate("/offline_course_records")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "12px 14px",
              marginBottom: "12px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <span className="navIcon">{iconMap["Student Records"]}</span>
            <span className="navText" style={{ fontSize: "17px", fontWeight: 600 }}>
              Offline Course Records
            </span>
          </button>


        </div>
      </div>
    </>
  );
}
